import React, { useState } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import { withRouter } from "react-router-dom";
import { adminActions } from "../../../../../redux/action";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import swal from 'sweetalert'
import { getConfig, numberFormat } from '../../../../../redux/config/config';
import { authHeader, history } from '../../../../../redux/logic';
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TextField,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button,
  Divider,
  Dialog,
  Grid,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Slide,
  CircularProgress,
} from '@material-ui/core';
import {Link} from 'react-router-dom';
import Paginate from 'views/pages/components/Users/UsersTable/paginate';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  bash:{
    width: 1020
  },
  formLabel: {
    alignItems: 'center',
    paddingLeft:10,
    paddingTop:15
  },
  formLabels: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
    alignItems: 'right'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const UsersTable = props => {
  const { className, loading, name, users,  investments, banks, status, ...rest} = props;
  const {savings} = props;

  const classes = useStyles();

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [rowsPerPages, setRowsPerPages] = useState(10);
  const [pages, setPages] = useState(0);

  const handleSelectAll = event => {
    const { users } = props;

    let selectedUsers;

    if (event.target.checked) {
      selectedUsers = users.map(user => user.id);
    } else {
      selectedUsers = [];
    }

    setSelectedUsers(selectedUsers);
  };


  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedUsers.indexOf(id);
    let newSelectedUsers = [];

    if (selectedIndex === -1) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers, id);
    } else if (selectedIndex === 0) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers.slice(1));
      console.log("index is 0")
    } else if (selectedIndex === selectedUsers.length - 1) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers.slice(0, -1));
      console.log("index is - user length -1")
    } else if (selectedIndex > 0) {
      newSelectedUsers = newSelectedUsers.concat(
        selectedUsers.slice(0, selectedIndex),
        selectedUsers.slice(selectedIndex + 1)
      );
    }

    setSelectedUsers(newSelectedUsers);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };
  const handleModalPageChange = (event, pages) => {
    setPages(pages);
  };

  const handleModalRowsPerPageChange = event => {
    setRowsPerPages(event.target.value);
  };
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
 });

const [open, setOpen] = useState(false);
const [disburst, setDisburst] = useState(false);
const [isLoading, setIsLoading] = useState(true);
const [details, setDetails] = useState([]);
const [singleData, setSingleData] = useState({});
const [bankData, setBankData] = useState({});

const handleOpen = (id) => {
  setIsLoading(true)
  console.log(id)
  setOpen(true);
  let user = JSON.parse(localStorage.getItem('admin'));
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  fetch(getConfig('getAllGuarantor') + id + `?token=`+user.token, requestOptions)
  .then(async response => {
  const data = await response.json();
  if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
  }
  console.log(data)
  if(data.success === false){
    setDetails([])
  }else{
    setDetails(data)
  }
  setIsLoading(false)
  })
  .catch(error => {
  if (error === "Unauthorized") {
      history.push('/login');
      }
      setIsLoading(false)
      console.error('There was an error!', error);
  });
};

  const handleClose = () => {
    setOpen(false);
    setDisburst(false);
    setBankData({})
  };

  const handleChange = (e) =>{
    setBankData({bank_id:e.target.value, id:singleData.id })
  }

  const handleDisburst = (id) =>{
    const data =  users.find((u,i)=>(u.id === id))
    console.log(data)
    setSingleData(data);
    setDisburst(true);
  }

  const handleSubmit = () =>{
    swal({
      title: "Are you sure you want to disburse?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        props.disburstLoan(bankData)
        swal("Loading...",{   
          buttons:false
        });
      }
    });
  }

  const handleApproved = (id) =>{
    swal({
      title: "Are you sure You want to Approve?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        props.adminApproveLoanz(id)
        swal("Loading...",{   
          buttons:false
        });
      }
    });
  }
  console.log(users)
 return (
  <Card className={clsx(classes.root, className)}>
      {/* Modal */}
      < Dialog
        open={open}
        fullWidth={true}
        maxWidth = {'xs'}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle  id="alert-dialog-slide-title">Guarantors</DialogTitle>  
        <Divider />     
        <DialogContent>
          {isLoading? <Typography>Loading...</Typography>:
          <List>
            {details.map((det, i) =>( 
            <ListItem
              divider={i < details.length - 1}
              key={det.id}
            >
              <ListItemText
                primary={`Guarantors Name: ${det.first_name + " " + det.last_name}`}
                secondary={`Guaranteed Amount: ${det.guaranteed_amount}`}
              />
            </ListItem>
            ))}
           </List>}
          
            <Grid container>
              <Grid item md={10} xs={10} style={{ marginTop: '1rem' }}>
                <Button onClick={handleClose} variant="contained" 
                  style={{marginLeft:10, color:'white', backgroundColor:'red'}}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
        </DialogContent>
      </Dialog>
      {/* Modal */}

      {/* Disburst Modal */}
      < Dialog
        open={disburst}
        fullWidth={true}
        maxWidth = {'xs'}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle  id="alert-dialog-slide-title">Loan Details</DialogTitle>  
        <Divider />
        <DialogContent>
          <List>
            <ListItem divider >
              <ListItemText
                primary={`Guarantors Name: ${singleData.first_name + " " + singleData.last_name}`}
              />
            </ListItem>
            <ListItem divider >
              <ListItemText
                primary={`Loan Amount: ${singleData.loan_amount}`}
              />
            </ListItem>
            <ListItem divider >
              <ListItemText
                primary={`Repayment Amount: ${singleData.repayment_amount}`}
              />
            </ListItem>
            <ListItem divider >
              <ListItemText
                primary={`Payment Duration: ${singleData.payment_duration}`}
              />
            </ListItem>
          </List>
              <TextField
                fullWidth
                select
                variant="outlined"
                value={singleData.bank_name} 
                onChange={handleChange}
                SelectProps={{
                  native: true,
                }}
                helperText="Please select Bank Name"
                name="bank_name">
                  <option></option>
                  {banks.map(b =>(<option key={b.id} value={b.id}>{b.bank_name}</option>))}
              </TextField>
              <Button onClick={handleSubmit} color="primary" variant="contained">
                Disburse
              </Button>
        </DialogContent>
      </Dialog>
      {/* Modal */}

    <CardContent className={classes.content}>
      <PerfectScrollbar>
        <div className={classes.inner}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Group Name</TableCell>
                <TableCell>Loan Amount</TableCell>
                <TableCell>Repayment Amount</TableCell>
                <TableCell>Frequency</TableCell>
                <TableCell>Start Date</TableCell>
                <TableCell colSpan={4}>Action</TableCell>
              </TableRow>
            </TableHead>
            
            <TableBody>
            {loading?
            <TableRow><TableCell><CircularProgress /></TableCell></TableRow>:
            users.length !== 0 ?
            users.map(user => (
              <TableRow
                className={classes.tableRow}
                hover
                key={user.id}
                selected={selectedUsers.indexOf(user.id) !== -1}>
                 <TableCell>{user.first_name + " " + user.last_name}</TableCell>
                 <TableCell>{user.group_name}</TableCell>
                <TableCell>{numberFormat(user.loan_amount)}</TableCell>
                <TableCell>{numberFormat(user.repayment_amount)}</TableCell>
                <TableCell>{user.frequency}</TableCell>
                <TableCell>{moment(user.start_date).format('DD/MM/YYYY')}</TableCell>
               { name =='pending'?
                <TableCell>
                      <Button color="primary" variant="contained" 
                        onClick={()=> handleOpen(user.id)}
                        >Guarantors</Button>&nbsp; &nbsp;
                        {status && <Button variant="contained" color="secondary" onClick={user.status === 2 ? ()=>handleApproved(user.id) : ()=>handleDisburst(user.id)} >{user.status === 2 ? 'Approved':'Disburse'}
                      </Button>}
                  </TableCell>:
                  <TableCell>
                      <Link to ={`/loandetails/${user.id}`}>
                        <Button color="primary" variant="contained" > Details</Button>
                      </Link>&nbsp;
                      <Button color="primary" variant="contained" 
                        onClick={()=> handleOpen(user.id)}
                        >Guarantors</Button>&nbsp; &nbsp;
                        {status && <Button variant="contained" color="secondary" onClick={user.status === 2 ? ()=>handleApproved(user.id) : ()=>handleDisburst(user.id)} >{user.status === 2 ? 'Approved':'Disburse'}
                      </Button>}
                  </TableCell>
                }
              </TableRow>
            )):
            <TableRow>
              <TableCell colSpan={8} style={{textAlign:"center"}}>
                No Record Found
              </TableCell> 
            </TableRow>
            }
          </TableBody>
         </Table>
        </div>
      </PerfectScrollbar>
    </CardContent>
    <Paginate pagination={props.pagination} fetch_prev_page={props.fetch_prev_page} fetch_next_page={props.fetch_next_page} fetch_page={props.fetch_page}/>
  </Card>
);
};

function mapState(state) {
  const { savings } = state.savings;
  return { savings };
}

const actionCreators = {
  logout: adminActions.logout,
  adminApproveLoanz: adminActions.adminApproveLoanz,
  disburstLoan: adminActions.disburstLoan,
};
// export default UsersTable;

export default withStyles({}, { withTheme: true })(
  withRouter(connect(mapState,actionCreators)(UsersTable))
);